import React from 'react';
import { Box, Stack, Text, Paper } from '@mantine/core';
import { CollectorType, ContextMessage } from '@/client/features/signals/types';

type Props = {
  message: ContextMessage;
  side: 'left' | 'right';
  isIndented?: boolean;
  collector: string;
  isDark: boolean;
};

export const MessageItem = React.memo(({ message, side, isIndented, collector, isDark }: Props) => {
  const isCurrent = message.current_message;
  const grid = side === 'left' ? '220px minmax(0,1fr)' : 'minmax(0,1fr) 220px';
  const authorName =
    collector === CollectorType.Telegram
      ? ((message as any).author?.User?.Username ?? 'Unknown')
      : (message.author as string);

  return (
    <Box
      style={{
        display: 'grid',
        gridTemplateColumns: grid,
        columnGap: 24,
        alignItems: 'start',
        width: '100%',
        paddingLeft: isIndented ? '16px' : 0,
      }}
    >
      {side === 'left' && (
        <Stack gap={2} align="flex-start">
          <Text fw={700} size="sm">
            {authorName}
          </Text>
          <Text c="dimmed" size="xs">
            {message.date}
          </Text>
        </Stack>
      )}

      <Paper
        withBorder={false}
        shadow="none"
        radius="sm"
        p="sm"
        bg={isCurrent ? (isDark ? 'rgba(255, 255, 255, 0.08)' : 'gray.1') : 'transparent'}
        style={{ width: '100%' }}
      >
        <div
          style={{ fontSize: 14, lineHeight: 1.6, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
        >
          {message.content}
        </div>
      </Paper>

      {side === 'right' && (
        <Stack gap={2} align="flex-end">
          <Text fw={700} size="sm">
            {authorName}
          </Text>
          <Text c="dimmed" size="xs">
            {message.date}
          </Text>
        </Stack>
      )}
    </Box>
  );
});
